import React from 'react';
import AppContext from '../../components/AppContext';
import Layout from '../../components/Layout';
import AdvisorResourcesContent from '../../components/AgentResources/AdvisorResourcesContent';


export default () => {
  const title = 'Agent Registration'
  const subTitle = 'Approved Agent resources like marketing materials, training, sample illustrations, enrollment forms, and more.'
  const props: any = {
    title,
    page: {
      'title': {
        'blocks': [
          {
            'key': '9qk7h',
            'text': title,
            'type': 'H2',
            'depth': 0,
            'inlineStyleRanges': [],
            'entityRanges': [],
            'data': {}
          }
        ], 'entityMap': {}
      },
      'subTitle': {
        'blocks': [
          {
            'key': 'fraau',
            'text': subTitle,
            'type': 'SUBTITLE1',
            'depth': 0,
            'inlineStyleRanges': [],
            'entityRanges': [],
            'data': {}
          }
        ], 'entityMap': {}
      },
      'strategyText': {
        'blocks': [
          {
            'key': '5ovo0',
            'text': 'Find Your Strategy',
            'type': 'H4',
            'depth': 0,
            'inlineStyleRanges': [],
            'entityRanges': [],
            'data': {}
          }
        ], 'entityMap': {}
      },
      'strategyDescendantText': {
        'blocks': [
          {
            'key': '9algj',
            'text': 'In less than 2 minutes, find the right strategy for your needs.',
            'type': 'BODY2',
            'depth': 0,
            'inlineStyleRanges': [],
            'entityRanges': [],
            'data': {}
          }
        ], 'entityMap': {}
      },
      'mapDescendantText': {
        'blocks': [
          {
            'key': '3dvc',
            'text': 'Tap a map pin to view agent details or zoom the map out if no agents show up in your immediate area. We may also have additional agents available that are not shown on the map so please call us at 1-800-294-9940 and we can get you in contact with an agent near you.',
            'type': 'CAPTION',
            'depth': 0,
            'inlineStyleRanges': [],
            'entityRanges': [],
            'data': {}
          }
        ], 'entityMap': {}
      },
      'mapTitle': {
        'blocks': [
          {
            'key': '81m1v',
            'text': 'Licensed Agents Map',
            'type': 'H2',
            'depth': 0,
            'inlineStyleRanges': [],
            'entityRanges': [],
            'data': {}
          }
        ], 'entityMap': {}
      },
      'bgImage': 'img-hero-agent-lookup.jpg',
      'carouselId': 3
    },
    data: {
      'subTitle': {
        'blocks': [
          {
            'key': 'fraau',
            'text': '',
            'type': 'SUBTITLE1',
            'depth': 0,
            'inlineStyleRanges': [],
            'entityRanges': [],
            'data': {}
          }
        ], 'entityMap': {}
      },
    },
    keyword: 'agent resources',
    description: 'Agent resources like marketing materials, training, sample illustrations, enrollment forms, and more. '
  };

  return (
    <AppContext.Provider value={props.page}>
      <Layout
        title={props.title}
        description={props.data.subTitle}
        keyword={props.keyword}
        pageDescription={props.description}
      >
        <AdvisorResourcesContent title={props.page.title} {...props.data} />
      </Layout>
    </AppContext.Provider>
  );
};
